import { render, staticRenderFns } from "./DropdownVariation.vue?vue&type=template&id=17b820d6&"
import script from "./DropdownVariation.vue?vue&type=script&lang=js&"
export * from "./DropdownVariation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports